'use strict';

import AOS from 'aos';

export function init() {
	const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches == true ||
	window.matchMedia('(prefers-reduced-motion: reduce)') == true;

	if (!reducedMotion) {
		AOS.init({
			once: true,
			duration: 600,
		});
	} else {
		AOS.init({
			once: true,
			duration: 2400,
		});
	}
}
